import { render, staticRenderFns } from "./WhiteLabelSelect.vue?vue&type=template&id=5d2651ea"
import script from "./WhiteLabelSelect.vue?vue&type=script&lang=js"
export * from "./WhiteLabelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports